export type HydrationGeneratedLessonRecord = Record<string, unknown>;

export const hydrationContentSelectionPriority = [
    (item: HydrationGeneratedLessonRecord) =>
        Boolean(item.is_canonical) && item.structured_content != null,
    (item: HydrationGeneratedLessonRecord) => item.structured_content != null,
    (item: HydrationGeneratedLessonRecord) => Boolean(item.is_canonical),
] as const;
